export const BEGIN = "BEGIN";
export const SUCCESS = "SUCCESS";
export const ERROR = "ERROR";

export type AsyncActionMode = "BEGIN" | "SUCCESS" | "ERROR";

export type AsyncAction<TAction, TData, TResponse> = { type: TAction, data: TData, response?: TResponse, error?: Error };
